import { Component, OnInit } from '@angular/core';
import { coinsService } from '../../services/coins.service';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { authService } from '../../services/auth.service';
import { Route, Router } from '@angular/router';
@Component({
  selector: 'app-featured-coin-section',
  templateUrl: './featured-coin-section.component.html',
  styleUrls: ['./featured-coin-section.component.scss'],
  standalone: false,
})
export class FeaturedCoinSectionComponent implements OnInit {


  customOptions: OwlOptions = {
    loop: true,
    mouseDrag: false,
    touchDrag: false,
    pullDrag: false,
    dots: false,
    navSpeed: 700,
    navText: [
      '<i class="fas fa-chevron-left" style="background-color: #007bff; border-radius: 50%;"></i>',
      '<i class="fas fa-chevron-right" style="background-color: #007bff; border-radius: 50%;"></i>'
    ],
    responsive: {
      0: {
        items: 1
      },
      400: {
        items: 1
      },
      740: {
        items: 3
      },
      940: {
        items: 3
      }
    },
    nav: true
  };

  coins

  constructor(
    private coinService: coinsService,
    public auth: authService,
    private router: Router
  ){

  }

  ngOnInit(): void {
    this.getFeaturedCoins();
  }


  transformBaseUrl: string = 'https://coincuriosity.us/cdn-cgi/image';
  getTransformedImageUrl(imageUrl: string, width: number = 150, quality: number = 75): string | null {
    if (!imageUrl) {
      return null;
    }
    return `${this.transformBaseUrl}/width=${width},quality=${quality}/${imageUrl}`;
  }


  isPersonal(coin): boolean {
    return !!this.auth?.userAuthData && this.auth.userAuthData.user.id === coin?.user_id;
  }

  getFeaturedCoins(){
    this.coinService.getFeaturedCoins().subscribe(res => {
      this.coins = res.data;
    })
  }



  isSimilarCoin:boolean = false;

  navigate(coin): void {
    this.router.navigate(['/coins/coin-detail', coin.id]);
    // if (this.auth.userAuthData) {
    //   if (this.isSimilarCoin) {
    //     this.router.navigate(['/coins/coin-detail', coin.id]);
    //     return;
    //   }
    //   if (this.isPersonal(coin)) {
    //     this.router.navigate(['/coins/coin-detail', coin.id]);
    //   } else {
    //     if (coin.status == 'identify') {
    //       this.router.navigate(['/coins/identify', coin.id]);
    //     }
    //     if (coin.status == 'assess') {
    //       this.router.navigate(['/coins/assess',coin.id]);
    //     }
    //   }
    // } else {
    //   this.router.navigate(['/user/login']);
    // }
  }

}
